var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.99414C6.486 1.99414 2 6.48014 2 11.9941V16.1371C2 17.1611 2.897 17.9941 4 17.9941H5C5.26522 17.9941 5.51957 17.8888 5.70711 17.7012C5.89464 17.5137 6 17.2594 6 16.9941V11.8511C6 11.5859 5.89464 11.3316 5.70711 11.144C5.51957 10.9565 5.26522 10.8511 5 10.8511H4.092C4.648 6.98114 7.978 3.99414 12 3.99414C16.022 3.99414 19.352 6.98114 19.908 10.8511H19C18.7348 10.8511 18.4804 10.9565 18.2929 11.144C18.1054 11.3316 18 11.5859 18 11.8511V17.9941C18 19.0971 17.103 19.9941 16 19.9941H14V18.9941H10V21.9941H16C18.206 21.9941 20 20.2001 20 17.9941C21.103 17.9941 22 17.1611 22 16.1371V11.9941C22 6.48014 17.514 1.99414 12 1.99414Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support-icon.95d9c38b065a2d0ca17f92d6d0eb7f4a.svg";
export { ForwardRef as ReactComponent };